/**
 * All Candidates Entry Point.
 * Creates its own bundle.
 */
import { Fragment, h } from 'preact';
import { useContext } from 'preact/compat';
import renderView, { StepCondition, Theme } from '../lib/render';
import CheckoutNavigation from '../components/checkout/CheckoutNavigation';
import CheckoutForm from '../components/checkout/CheckoutForm';
import Inventory, { InventoryDrawer } from '../components/Inventory';
import Intro from '../components/Intro';
import { DonationStepEnum, useDonationStep } from '../hooks/step';
import Success from '../components/Success';
import PostQuery from '../components/SearchQuery';
import { useSourceCodeUrlParam } from '../hooks/urlParams';

/**
 * Assemble UI.
 */
const AllCandidates = () => {
	const theme = useContext(Theme);
	const step = useDonationStep();

	// Use source code URL param.
	useSourceCodeUrlParam(theme);

	return (
		<Fragment>
			<StepCondition
				step={DonationStepEnum.SUCCESS}
				inclusive={false}
			>
				<div
					className={[
						'ea-all-candidates ea-standard ea-grid-col container',
						step.state,
					].join(' ')}
				>
					<div className="ea-top">
						<Intro />
						<CheckoutNavigation />
					</div>
					<StepCondition
						step={DonationStepEnum.ENTRY}
						inclusive
					>
						<PostQuery />
					</StepCondition>
					<CheckoutForm />
					<aside>
						<div className="ea-sticky-inner-aside">
							<Inventory />
						</div>
					</aside>
					<InventoryDrawer />
				</div>
			</StepCondition>
			{/* Success full page takeover */}
			<StepCondition
				step={DonationStepEnum.SUCCESS}
				inclusive
			>
				<Success />
			</StepCondition>
		</Fragment>
	);
};

renderView(<AllCandidates />);
